/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationHistoryAliases {
  ACTION_ADD_HISTORY = 'action-add-history',
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AVATAR_0 = 'avatar-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_HISTORIES = 'deck-histories',
  FETCH_HISTORIES = 'fetch-histories',
  FETCH_NEGOTIATION = 'fetch-negotiation',
  FETCH_TYPE = 'fetch-type',
  FIELD_0 = 'field-0',
  FIELD_HISTORY = 'field-history',
  FIELD_MESSAGE = 'field-message',
  FIELD_TYPE = 'field-type',
  FORM_FAKE = 'form-fake',
  FORM_HISTORY = 'form-history',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_3 = 'mapper-3',
  MODAL_HISTORY = 'modal-history',
  PANEL_0 = 'panel-0',
  PANEL_ADD_HISTORY = 'panel-add-history',
  PANEL_NEGOTIATION_HISTORY = 'panel-negotiation-history',
  TEXT_3 = 'text-3',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_HTML_HISTORY = 'text-html-history',
}
export { NegotiationHistoryAliases };
